export const SET_FETCHING_PROJECT_CERTTEXT = 'SET_FETCHING_PROJECT_CERTTEXT';
export const SET_PROJECT_CERTTEXT_ERROR = 'SET_PROJECT_CERTTEXT_ERROR';
export const SET_PROJECT_CERTTEXT = 'SET_PROJECT_CERTTEXT';

export const SET_EDIT_PROJECT_CERTTEXT_ERROR = 'SET_EDIT_HOLDER_SETTINGS_ERROR';
export const SET_EDIT_PROJECT_CERTTEXT = 'SET_EDIT_PROJECT_CERTTEXT';
export const SET_EDIT_PROJECT_CERTTEXT_SUCCESS = 'SET_EDIT_PROJECT_CERTTEXT_SUCCESS';
